"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

function ChromaKey(a) {
  var b = a.chromaKey,
      c = a.onChangeAddon,
      d = a.CHROMA_KEY,
      e = a.disabled;
  return _react["default"].createElement(_uiKit.Dropdown, {
    options: d,
    defaultValue: b ? d.find(function (a) {
      return a.value === b;
    }) : d[0],
    label: "Green Screen",
    onChange: c("CHROMA_KEY"),
    hideSeparators: !0,
    showSelectedSuffix: !0,
    disabled: e,
    type: "BUTTON"
  });
}

var _default = (0, _react.memo)(ChromaKey);

exports["default"] = _default;